import { TranslateService } from '@ngx-translate/core';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { KPI } from '../../../@core/api';
import { ChartFiltersService } from '../../../@core/utils';

import { FormsModule } from '@angular/forms';
import { NbRadioModule } from '@nebular/theme';

@Component({
    selector: 'app-consumption-emission-filter',
    templateUrl: './consumption-emission-filter.component.html',
    styleUrls: ['./consumption-emission-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
    NbRadioModule,
    FormsModule
],
})
export class ConsumptionEmissionFilterComponent implements OnInit, OnDestroy {

  public filterOptions = [
    {
      value: KPI.FeasibilityConsumptionOrEmissionFilter.CONSUMPTION,
      label: this.translate.instant('Impact on kWh ratio'),
    },
    {
      value: KPI.FeasibilityConsumptionOrEmissionFilter.EMISSION,
      label: this.translate.instant('Impact on kg CO2e ratio'),
    },
  ];
  public filter: number;

  private subscriptions: Subscription[] = [];

  constructor(
    private chartFiltersService: ChartFiltersService,
    private translate: TranslateService,
    private cdRef: ChangeDetectorRef,
  ) { }

  public ngOnInit(): void {
    this.subscriptions.push(
      this.chartFiltersService.filter$('feasibilityConsumptionOrEmission').subscribe((filter) => {
        this.filter = <number>filter;
        this.cdRef.detectChanges();
      }),
    );
  }

  public filterChanged(): void {
    setTimeout(() => {
      this.chartFiltersService.setFilter('feasibilityConsumptionOrEmission', this.filter);
    }, 50);
  }


  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

}